










import { Vue, Component, Prop } from 'vue-property-decorator'
import { ECallbackType } from '../services/CallbackService'

@Component
export default class Header extends Vue {
  @Prop({ default: '' }) readonly title!: string | null
  @Prop({ default: false }) readonly showClose!: boolean

  close () {
    Vue.prototype.$callback.call(ECallbackType.shouldExit)
  }
}
